<div class="field-selector">
  <ng-container *ngIf="selectedFields$ | async as selectedFields">
    <mat-form-field>
      <mat-label>Select fields</mat-label>
      <mat-select
        [appAuthorize]="canEdit"
        denyAction="disable"
        *ngIf="!groupMode; else groupSelect"
        #selectField
        (selectionChange)="fieldSelectionChange($event)"
        (openedChange)="fieldSelectionOpenedChange()"
        multiple
        [value]="selectedFields"
      >
        <mat-form-field class="sticky top-0 z-10 w-full p-2 pb-0 search-field">
          <input
            [formControl]="searchField"
            matInput
            placeholder="Search..."
            autocomplete="off"
            (keydown)="$event.stopPropagation()"
          />
        </mat-form-field>
        <mat-option
          *ngFor="let field of fields"
          [value]="field.name"
          [class.display-none]="field.label?.toLowerCase().indexOf(searchField.value.toLowerCase()) === -1"
        >
          {{ field.label }}
        </mat-option>
      </mat-select>
      <ng-template #groupSelect>
        <mat-select
          [appAuthorize]="canEdit"
          denyAction="disable"
          #selectField
          (selectionChange)="fieldSelectionChange($event)"
          (openedChange)="fieldSelectionOpenedChange()"
          multiple
          [value]="selectedFields"
          panelClass="field-selector__select"
        >
          <mat-form-field class="sticky top-0 z-10 w-full p-2 pb-0 search-field">
            <input
              [formControl]="searchField"
              matInput
              placeholder="Search..."
              autocomplete="off"
              (keydown)="$event.stopPropagation()"
            />
          </mat-form-field>
          <mat-optgroup
            *ngFor="let group of fields | groupBy: 'group' : 'label' : ['Time Series']"
            [label]="getGroupLabel(group.groupName)"
            [class.display-none]="
              (searchField.valueChanges | async | mutateToAny: hasSearchMatchInGroup : group.items) === false
            "
          >
            <ng-container
              *ngFor="let item of group.items | filterBy: [''] : null : removeDealFieldIfTSAlreadyExist.bind(this)"
            >
              <ng-container *ngIf="item?.nestedFields?.length <= 0">
                <mat-option
                  [value]="item.name"
                  [class.display-none]="
                    item.meta?.filtering?.exclude_in_nested_fields ||
                    item.label?.toLowerCase().indexOf(searchField.value.toLowerCase()) === -1 ||
                    hideDealName(item)
                  "
                >
                  {{ item.label }}
                </mat-option>
              </ng-container>

              <ng-container *ngIf="item?.nestedFields?.length >= 1">
                <mat-option
                  *ngFor="let childItem of item.nestedFields"
                  [value]="childItem.name"
                  [class.subitem]="!childItem.name.includes('_linked_')"
                  [class.display-none]="
                    childItem.meta?.filtering?.exclude_in_nested_fields ||
                    childItem.label?.toLowerCase().indexOf(searchField.value.toLowerCase()) === -1
                  "
                >
                  {{ childItem.label }}
                </mat-option>
              </ng-container>
            </ng-container>
          </mat-optgroup>
        </mat-select>
      </ng-template>
    </mat-form-field>
    <ng-container *ngIf="!openSelect">
      <ng-container *ngIf="selectedFields?.length; else noFieldSelected">
        <div *ngIf="groupMode || isTimeSeries; else default">
          <ng-container *ngFor="let listGroup of listGroups">
            <ng-container *ngIf="selectedFieldsFromGroup(selectedFields, listGroup) | async as groupFields">
              <ng-container *ngIf="groupFields.length > 0">
                <p class="group-header">{{ getGroupLabel(listGroup) }}</p>
                <ul class="selected-fields">
                  <li *ngFor="let selectedField of groupFields">
                    <span>{{ selectedField?.label || getFieldLabel(selectedField) }}</span>
                    <div>
                      <ts-button
                        *ngIf="canHaveFormula(selectedField)"
                        [debounceTime]="0"
                        [appAuthorize]="canEdit"
                        denyAction="disable"
                        icon="functions"
                        color="accent"
                        type="icon"
                        [iconColor]="hasFormula(selectedField) ? 'orange' : 'light-gray'"
                        (click)="setFieldSelected(selectedField)"
                        [tsOverlayTriggerFor]="overlayBox"
                        [alwaysEmitClick]="true"
                      >
                      </ts-button>
                      <ts-button
                        (click)="removeField(selectedField.name || selectedField)"
                        [debounceTime]="0"
                        [appAuthorize]="canEdit"
                        denyAction="disable"
                        matTooltip="Remove field"
                        icon="close"
                        color="accent"
                        type="icon"
                        data-cy="report-builder-field-selection-delete-field"
                      >
                      </ts-button>
                    </div>
                  </li>
                </ul>
              </ng-container>
            </ng-container>
          </ng-container>
        </div>
        <ng-template #default>
          <ul class="selected-fields">
            <li *ngFor="let selectedField of selectedFields">
              <span>{{ getFieldLabel(selectedField) }}</span>
              <div>
                <ts-button
                  *ngIf="canHaveFormula(null, selectedField)"
                  [debounceTime]="0"
                  [appAuthorize]="canEdit"
                  denyAction="disable"
                  icon="functions"
                  color="accent"
                  type="icon"
                  [iconColor]="hasFormula(null, selectedField) ? 'orange' : 'light-gray'"
                  (click)="setFieldSelected(null, selectedField)"
                  [tsOverlayTriggerFor]="overlayBox"
                  [alwaysEmitClick]="true"
                >
                </ts-button>
                <ts-button
                  (click)="removeField(selectedField)"
                  [debounceTime]="0"
                  [appAuthorize]="canEdit"
                  denyAction="disable"
                  matTooltip="Remove field"
                  icon="close"
                  color="accent"
                  type="icon"
                  data-cy="report-builder-field-selection-delete-field"
                >
                </ts-button>
              </div>
            </li>
          </ul>
        </ng-template>
      </ng-container>
      <ng-template #noFieldSelected>
        <p class="field-selector__empty-selection"><mat-icon>text_fields</mat-icon>No field selected</p>
      </ng-template>
    </ng-container>
  </ng-container>
</div>
<ts-overlay #overlayBox position="right" [transparentBackdrop]="true">
  <div class="formula-list-container">
    <p>Formula Toggle</p>
    <ul class="formula-list">
      <li
        *ngFor="let formula of formulas$ | async"
        (click)="formulaClick(formula)"
        [class.selected]="isFormulaSelected(formula)"
      >
        {{ formula.label }}
        <mat-icon *ngIf="isFormulaSelected(formula)">check_circle_outline</mat-icon>
      </li>
    </ul>
  </div>
</ts-overlay>
